import 'ng-file-upload';
import _ from 'lodash';
import { isExtensionValid, getFileMetaData } from '../../../utils/fileCheck';

import template from './patient-file-transfer.html';
import { RootScopeEvents } from 'common/services/root-scope-types';

export default angular
  .module('doxy.common.components.file-transfer.patient-file-transfer', [
    'ngFileUpload',
  ])
  .component('filePatientTransfer', {
    template: template,
    bindings: {
      state: '<',
      target: '<',
      innerMediator: '<',
    },
    controller: function (
      $window,
      notificationFactory,
      Upload,
      apiUrl,
      VideoProviderFactory,
      pn,
      $rootScope
    ) {
      const mb = 1000000;
      const limitMb = 100;

      this.upload = (files) => {
        const file = files && files[0];
        if (!file) return;
        if (file.size > limitMb * mb) {
          notificationFactory.showCommon(
            'info',
            'file-transfer.fileLimit{{limitMb}}',
            null,
            5000,
            {
              limitMb,
            }
          );
          return;
        }

        const fileMetaData = getFileMetaData(file);

        if (isExtensionValid(file.name) === false) {
          notificationFactory.showCommon(
            'info',
            'file-transfer.file-not-supported'
          );
          return;
        }

        this.state.notificationsStatus = 'UPLOADING';

        Upload.upload({
          url: apiUrl + `/api/privateStorages/uploadFile`,
          file: file,
          params: {
            token: this.state.token,
            temporary: true,
          },
        })
          .then(({ data }) => {
            $rootScope.$emit(RootScopeEvents.FILE_TRANSFER.FINISHED, {
              user_type: 'patient',
              room_id: this.target.roomId,
              session_id: _.get(
                VideoProviderFactory,
                'activeProvider.callSession.id',
                null
              ),
              extension: fileMetaData.extension,
              mime: file.type,
            });
            this.innerMediator.emit('patientUpload', {
              url: data.url,
              name: file.name,
              size: file.size,
            });
          })
          .catch((e) => {
            this.innerMediator.emit('patientUploadError', e);
          });
      };

      this.accept = () => {
        this.innerMediator.emit('accept');
      };

      this.close = () => {
        this.innerMediator.emit('cancel');
      };
    },
  }).name;
